import { Component, OnInit, ViewChild } from '@angular/core';
import { Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { MatPaginator } from '@angular/material/paginator';

import { Formats } from '../core/constants';


@Component({
  selector: 'tv-pending-transaction-list',
  templateUrl: './pending.transaction.list.component.html',
  styleUrls: ['./pending.transaction.list.component.css']
})
export class PendingTransactionListComponent implements OnInit {
  dataSource: any;
  row: any;
  title: string;

  @ViewChild(MatPaginator, { static: true }) paginator: MatPaginator;

  displayedColumns = ['referenceNo', 'amount', 'requiredAuthorisations', 'completedAuthorisations', 'createdByName', 'transactionDate'];
  constructor(public dialogRef: MatDialogRef<PendingTransactionListComponent>,
    public formats: Formats,
    @Inject(MAT_DIALOG_DATA) public data: any) { }

  ngOnInit() {
    console.log('data of pending txn', this.data);
    this.title = 'Todays Transactions';
    this.dataSource = this.data.rows;
    console.log('data', this.dataSource);
  }

  openTransactionView(journalTransactionId: number) {
    window.open(`/transaction/view/${journalTransactionId}/1`);
  }

  onCancel(): void {
    this.dialogRef.close();
  }

}
